// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"4da1aef5","453":"31bf9d75","768":"5c7994ea"}[chunkId] + ".chunk.js";
};